export const kazakhstanRegions = [
    { id: 'KZ11', name: 'Акмолинская область' },
    { id: 'KZ15', name: 'Актюбинская область' },
    { id: 'KZ19', name: 'Алматинская область' },
    { id: 'KZ75', name: 'г. Алматы' },
    { id: 'KZ23', name: 'Атырауская область' },
    { id: 'KZ10', name: 'Абайская область' },
    { id: 'KZ31', name: 'Жамбылская область' },
    { id: 'KZ62', name: 'Улытауская область' },
    { id: 'KZ27', name: 'Западно-Казахстанская область' },
    { id: 'KZ35', name: 'Карагандинская область' },
    { id: 'KZ39', name: 'Костанайская область' },
    { id: 'KZ43', name: 'Кызылординская область' },
    { id: 'KZ47', name: 'Мангистауская область' },
    { id: 'KZ59', name: 'Северо-Казахстанская область' },
    { id: 'KZ71', name: 'г. Астана' },
    { id: 'KZ55', name: 'Павлодарская область' },
    { id: 'KZ79', name: 'г. Шымкент' },
    { id: 'KZ61', name: 'Туркестанская область' },
    { id: 'KZ33', name: 'Жетысуская область' },
    { id: 'KZ63', name: 'Восточно-Казахстанская область' }
];